// Date helpers shared by the admin account view. The license-code admin
// operations (mint / setTier / setExpiration / revoke / delete) were retired
// when license codes were replaced by email-keyed access grants — all access
// writes now go through Cloud Function callables (see src/functions/accessApi.js
// and functions/index.js). Only the <input type="date"> helpers survive, reused
// by the "Grant Temporary Access" form.

// --- <input type="date"> <-> Date helpers ----------------------------------
// Build/parse from Y/M/D parts so the value round-trips in local time (a plain
// `new Date("YYYY-MM-DD")` parses as UTC midnight and can shift a day).

export function dateToInputValue(date) {
  if (!date) {
    return "";
  }
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )}`;
}

export function inputValueToDate(str) {
  if (!str) {
    return null;
  }
  const [y, m, d] = str.split("-").map(Number);
  // End-of-day local so a grant is valid through the whole chosen date.
  return new Date(y, m - 1, d, 23, 59, 59);
}

// A plain object shaped like a Firestore Timestamp (read via `.seconds`), used
// for optimistic local state so freshly-written dates match fetched docs.
export function toTimestampLike(date) {
  return { seconds: Math.floor(date.getTime() / 1000), nanoseconds: 0 };
}
